@if (workStation$ | async; as workStation) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workStation }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workStation }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="wsDetailTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'actions.delete' | translate }}</span>
                  </button>
                </mat-menu>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #mainFrm="ngForm" class="flex layout-col">
                <div class="layout-row gap-xl">
                  <!-- Identification -->
                  <div class="flex layout-col">
                    <h4 elderpaneSubtitle>{{ 'context.identification' | translate }}</h4>
                    <div class="layout-row gap-md">
                      <mat-form-field>
                        <elder-select
                          appFacilitySelect
                          name="facility"
                          class="flex"
                          placeholder="{{ 'facilities.facility' | translate }}"
                          required
                          valueAsId
                          [(ngModel)]="workStation.facility"
                          [disabled]="!creationMode"
                        >
                        </elder-select>
                      </mat-form-field>
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.number' | translate }}</mat-label>
                        <input
                          matInput
                          name="number"
                          required
                          placeholder="{{ 'context.number' | translate }}"
                          [(ngModel)]="workStation.number"
                          #numberModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                    </div>
                    <div class="layout-row gap-md">
                      <mat-form-field>
                        <mat-label>{{ 'context.type' | translate }}</mat-label>
                        <elder-select
                          appWorkStationTypeSelect
                          name="type"
                          class="flex"
                          required
                          valueAsId
                          [(ngModel)]="workStation.type"
                        >
                        </elder-select>
                      </mat-form-field>
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.name' | translate }}</mat-label>
                        <input
                          matInput
                          name="name"
                          placeholder="{{ 'context.name' | translate }}"
                          [(ngModel)]="workStation.name"
                        />
                      </mat-form-field>
                    </div>
                    <div class="layout-row gap-md">
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.description' | translate }}</mat-label>
                        <input
                          matInput
                          name="description"
                          placeholder="{{ 'context.description' | translate }}"
                          [(ngModel)]="workStation.description"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <mat-tab label="{{ 'properties.title' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'properties.title' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content padding="0">
              <app-property-conf-table
                [name]="'properties'"
                class="flex"
                [properties]="properties$ | async"
              >
              </app-property-conf-table>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <mat-tab label="Gateway">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'gateway.title' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button
                  mat-icon-button
                  [disabled]="!gatewayFrm.form.valid"
                  (click)="onSave($event)"
                >
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #gatewayFrm="ngForm" class="flex layout-col">
                <div class="layout-col">
                  <div class="layout-row" style="padding-bottom: 10px">
                    <mat-checkbox name="gateway-enabled" [(ngModel)]="workStation.gateway.enabled">
                      {{ 'context.enabled' | translate }}
                    </mat-checkbox>
                  </div>
                  <h4 elderpaneSubtitle>{{ 'gateway.properties' | translate }}</h4>
                  <mat-form-field class="flex">
                    <mat-label>{{ 'gateway.connection-string' | translate }}</mat-label>
                    <input
                      matInput
                      name="connection-string"
                      placeholder="{{ 'gateway.connection-string' | translate }}"
                      [(ngModel)]="workStation.gateway.connectionString"
                    />
                  </mat-form-field>
                </div>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <mat-tab label="{{ 'context.config' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'context.config' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button
                  mat-icon-button
                  [disabled]="!gatewayFrm.form.valid"
                  (click)="onSave($event)"
                >
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #gatewayFrm="ngForm" class="flex layout-col">
                <app-work-station-configuration-browser
                  class="flex"
                  [(configurations)]="workStation.configurations"
                >
                </app-work-station-configuration-browser>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-workStation>
  @if (creationMode) {
    <span>
      {{ 'shopfloor.workstations.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="workStation.name" [subheader]="'ID: ' + workStation.id"> </elder-header>
  }
</ng-template>
